/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import PostTypeService from "../../services/postTypeService";

const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] });
const cacheLtr = createCache({ key: 'ltr' });

const PostTypeDropdown = ({ helperText, error, setFormValues, isFilter, selectedPostType, setSelectedPostType }) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const [postTypes, setPostTypes] = useState([]);

    useEffect(() => {
        const fetchPostTypes = async () => {
            try {
                const data = await PostTypeService.fetchAll();
                setPostTypes(data);
            } catch (error) {
                console.error('Error fetching pages:', error);
            }
        };
        fetchPostTypes();
    }, []);

    return (
        <CacheProvider value={i18n.language === 'en' ? cacheLtr : cacheRtl}>
            <Autocomplete
                options={postTypes}
                getOptionLabel={(option) => option.name || ""}
                value={selectedPostType}
                onChange={(event, newValue) => {
                    setSelectedPostType(newValue);
                    setFormValues && setFormValues((prevValues) => ({
                        ...prevValues,
                        postTypeId: newValue ? newValue.id : null,
                    }));
                }
                }
                renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                        {option.name}
                    </li>
                )}
                renderInput={(params) => (
                    <Box>
                        {
                            !isFilter && <p
                                style={{
                                    color: theme.palette.text.primary,
                                    fontSize: 13,
                                    marginTop: 24,
                                    marginBottom: 4,
                                }}
                            >
                                {t("postType")}
                            </p>
                        }

                        <TextField
                            {...params}
                            variant={isFilter ? 'standard' : 'outlined'}
                            fullWidth
                            placeholder={isFilter ? t('postType') : t('choosePostType')}
                            error={!!error}
                            helperText={helperText}
                            InputProps={{
                                ...params.InputProps,
                                ...(isFilter ? { disableUnderline: true } : {}),
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                                style: {
                                    backgroundColor: isFilter ? 'transparent' : theme.palette.customGrey.insideInput,
                                    padding: '6px 8px',
                                },
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: theme.palette.customGrey.borderInput,
                                    },
                                    '&:hover fieldset': {
                                        borderColor: theme.palette.customGrey.borderInput,
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: theme.palette.primary.main,
                                    },
                                },
                                '& .MuiInputBase-input': {
                                    color: theme.palette.text.primary,
                                    padding: '6px 8px',
                                    '&::placeholder': {
                                        fontSize: '14px',
                                        color: theme.palette.text.secondary,
                                        opacity: 1,
                                    },
                                },
                            }}
                        />
                    </Box>
                )}
            />
        </CacheProvider>
    );
}

export default PostTypeDropdown;